<div class="season-passes-panel">
    <div class="btns-filters">
        <div class="filters-left">
            <div class="buscador-event container-form d-flex align-items-center borderInput">
                <i class="fal fa-search search-icon pointer-in"></i>
                <input class="input-custom w-100" type="text" placeholder="Buscar por nº de abonado, nombre, NIF o email"
                    [ngModel]="searchText" (input)="onSearch($any($event.target).value)">
            </div>
            <div class="filter-group">
                <div class="filter-pill" [class.active]="seasonFilter !== ''" (click)="seasonDropdownOpen = !seasonDropdownOpen">
                    <i class="fal fa-calendar-range"></i>
                    <span>{{ seasonFilterLabel }}</span>
                    <i class="fal fa-chevron-down chevron" [class.open]="seasonDropdownOpen"></i>
                </div>
                <div class="filter-dropdown" *ngIf="seasonDropdownOpen">
                    <div class="filter-option" [class.selected]="seasonFilter === ''" (click)="selectSeasonFilter('')">Todas las temporadas</div>
                    <div class="filter-option" *ngFor="let s of seasons" [class.selected]="seasonFilter === s.id" (click)="selectSeasonFilter(s.id)">{{ s.name }}</div>
                </div>
            </div>
            <div class="filter-group">
                <div class="filter-pill" [class.active]="statusFilter !== ''" (click)="statusDropdownOpen = !statusDropdownOpen">
                    <i class="fal fa-signal-bars"></i>
                    <span>{{ statusFilterLabel }}</span>
                    <i class="fal fa-chevron-down chevron" [class.open]="statusDropdownOpen"></i>
                </div>
                <div class="filter-dropdown" *ngIf="statusDropdownOpen">
                    <div class="filter-option" [class.selected]="statusFilter === ''" (click)="selectStatusFilter('')">Todos los estados</div>
                    <div class="filter-option" *ngFor="let s of statusOptions" [class.selected]="statusFilter === s.slug" (click)="selectStatusFilter(s.slug)">{{ s.name }}</div>
                </div>
            </div>
            <button class="btn-clear" *ngIf="searchText || seasonFilter || statusFilter" (click)="clearFilters()">
                <i class="fal fa-xmark"></i> Limpiar
            </button>
        </div>
        <div class="btns-create">
            <!-- DESACTIVADO 31-08-2026: renovación de los abonados migrados del
                 sistema anterior, que ahora se dan de alta desde cero como
                 cualquier otro. Se descomenta junto a openRenewals() y a las
                 rutas 'sports-passes/renewals'.
            <div class="btn-create btn-create--secondary m-0" (click)="openRenewals()">
                <i class="fal fa-rotate-right"></i>
                <p class="m-0">Renovar abonado</p>
            </div>
            -->
            <div class="btn-create m-0" (click)="openCreate()">
                <i class="fal fa-plus-circle"></i>
                <p class="m-0">Dar de alta abono</p>
            </div>
        </div>
    </div>

    <!-- Altas hechas con «Cobrar más tarde»: siguen pendientes y sin pedido.
         El aviso las hace visibles y el enlace deja el listado filtrado. -->
    <div class="pending-charge-notice" *ngIf="loaded && !loadingPage && chargeableCount > 0 && statusFilter === ''">
        <i class="fal fa-cash-register"></i>
        <span>
            Hay <b>{{ chargeableCount }}</b> {{ chargeableCount === 1 ? 'abono pendiente de cobro' : 'abonos pendientes de cobro' }}.
            {{ chargeableCount === 1 ? 'Puedes cobrarlo desde su menú de acciones.' : 'Puedes cobrarlos desde el menú de acciones de cada uno.' }}
        </span>
        <button type="button" class="pending-charge-link" (click)="selectStatusFilter('pending')">Ver pendientes</button>
    </div>

    <div *ngIf="loadingPage" class="container-lottie">
        <div class="loading-container">
            <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                containerClass="loading-box"></ng-lottie>
        </div>
    </div>

    <!-- El listado llega paginado: al llegar al final de la tabla se pide la
         página siguiente (ver isScrolledInfinityView). -->
    <div #containerScroll class="bg-transparent" *ngIf="loaded" (scroll)="isScrolledInfinityView($event)">
    <div class="table-events table-panel multiple-lines desktop-view">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z28" matSort>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let p">
                    <div [matMenuTriggerFor]="actionMenu" class="pointer-in d-flex justify-content-center"
                        style="width: 20px;">
                        <i class="icon-option fal fa-ellipsis-vertical"></i>
                    </div>
                    <mat-menu class="options-menu-control-panel" #actionMenu="matMenu">
                        <!-- Abono aún sin cobrar (alta con «Cobrar más tarde»):
                             lleva a la pantalla de cobro en taquilla. Sin butaca
                             no se puede cobrar, así que se deshabilita. -->
                        <button mat-menu-item *ngIf="canCharge(p)" (click)="openCheckout(p)"
                            [disabled]="!canChargeNow(p)"
                            [title]="canChargeNow(p) ? '' : 'Asígnale una butaca antes de cobrarle'">
                            <i class="fal fa-cash-register" style="margin-right: 8px;"></i>Cobrar
                        </button>
                        <button mat-menu-item (click)="openEdit(p)"><i class="fal fa-pen-to-square" style="margin-right: 8px;"></i>Editar</button>
                        <button mat-menu-item (click)="deletePass(p)" class="delete-action"><i class="fal fa-trash-can" style="margin-right: 8px;"></i>Eliminar</button>
                    </mat-menu>
                </td>
            </ng-container>

            <!-- Nº de abonado: se autoasigna al alta y es único por espacio, así
                 que es el identificador con el que el club pregunta por alguien
                 —y por el que se puede buscar en el buscador de arriba. -->
            <ng-container matColumnDef="member_number">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-hashtag th-icon"></i> Nº abonado</b></th>
                <td mat-cell *matCellDef="let p">
                    <span class="member-number">{{p.member_number || '—'}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header><b><i class="fal fa-user th-icon"></i> Nombre</b></th>
                <td mat-cell *matCellDef="let p" (click)="openEdit(p)">
                    <span class="link-titulo">{{p.user?.name}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="season">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-calendar-range th-icon"></i> Temporada</b></th>
                <td mat-cell *matCellDef="let p">
                    <span class="season-chip">{{p.season?.name}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="contact">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-address-card th-icon"></i> Contacto</b></th>
                <td mat-cell *matCellDef="let p">
                    <span class="contact-display">
                        {{p.user?.nif}}<br>
                        <span class="contact-email">{{p.user?.email}}</span>
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="registered_at">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-calendar th-icon"></i> Fecha alta</b></th>
                <td mat-cell *matCellDef="let p">
                    <span class="dates-display">{{p.registered_at | date:'dd/MM/yyyy'}}</span>
                </td>
            </ng-container>

            <!-- Tipo de abono contratado: consta en la última renovación, no en
                 el abono. Sin butaca no se puede cobrar, porque el abono que
                 paga depende del nivel de esta. -->
            <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-cart-shopping th-icon"></i> Abono</b></th>
                <td mat-cell *matCellDef="let p">
                    <span class="no-seat-badge" *ngIf="!p.seat" title="Asígnale una butaca para poder cobrarle">
                        <i class="fa-solid fa-triangle-exclamation"></i> Sin butaca
                    </span>
                    <span class="contact-display" *ngIf="p.seat">
                        {{ p.latest_renewal?.product?.name || '—' }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-signal-bars th-icon"></i> Estado</b></th>
                <td mat-cell *matCellDef="let p">
                    <span class="status-badge" [ngClass]="getStatusBadgeClass(p)">
                        <i class="fa-solid" [ngClass]="getStatusIcon(p)"></i>
                        {{p.status?.name}}
                    </span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

        <!-- Vista de tarjetas para móvil: las mismas filas que la tabla, una por
             tarjeta. Va dentro de #containerScroll para que el scroll infinito
             siga funcionando aquí igual que con la tabla. -->
        <div class="mobile-view list-cards">
            <div class="list-card" *ngFor="let p of passes">
                <div class="card-top">
                    <p class="card-title" (click)="openEdit(p)">{{p.user?.name}}</p>
                    <div class="card-menu" [matMenuTriggerFor]="cardMenu">
                        <i class="icon-option fal fa-ellipsis-vertical"></i>
                    </div>
                    <mat-menu class="options-menu-control-panel" #cardMenu="matMenu">
                        <button mat-menu-item *ngIf="canCharge(p)" (click)="openCheckout(p)"
                            [disabled]="!canChargeNow(p)"
                            [title]="canChargeNow(p) ? '' : 'Asígnale una butaca antes de cobrarle'">
                            <i class="fal fa-cash-register" style="margin-right: 8px;"></i>Cobrar
                        </button>
                        <button mat-menu-item (click)="openEdit(p)"><i class="fal fa-pen-to-square" style="margin-right: 8px;"></i>Editar</button>
                        <button mat-menu-item (click)="deletePass(p)" class="delete-action"><i class="fal fa-trash-can" style="margin-right: 8px;"></i>Eliminar</button>
                    </mat-menu>
                </div>

                <div class="card-rows">
                    <div class="card-row" *ngIf="p.member_number">
                        <i class="fal fa-hashtag"></i>
                        <span class="card-row-value">Nº {{p.member_number}}</span>
                    </div>
                    <div class="card-row" *ngIf="p.user?.nif">
                        <i class="fal fa-id-badge"></i>
                        <span class="card-row-value">{{p.user.nif}}</span>
                    </div>
                    <div class="card-row" *ngIf="p.user?.email">
                        <i class="fal fa-envelope"></i>
                        <span class="card-row-value card-row-muted">{{p.user.email}}</span>
                    </div>
                    <div class="card-row" *ngIf="p.seat">
                        <i class="fal fa-cart-shopping"></i>
                        <span class="card-row-value">{{ p.latest_renewal?.product?.name || '—' }}</span>
                    </div>
                    <div class="card-row">
                        <i class="fal fa-calendar"></i>
                        <span class="card-row-value card-row-muted">Alta {{p.registered_at | date:'dd/MM/yyyy'}}</span>
                    </div>
                </div>

                <div class="card-foot">
                    <span class="status-badge" [ngClass]="getStatusBadgeClass(p)">
                        <i class="fa-solid" [ngClass]="getStatusIcon(p)"></i>
                        {{p.status?.name}}
                    </span>
                    <span class="season-chip">{{p.season?.name}}</span>
                    <span class="no-seat-badge" *ngIf="!p.seat">
                        <i class="fa-solid fa-triangle-exclamation"></i> Sin butaca
                    </span>
                </div>
            </div>
        </div>

        <div class="pagination-component">
            <div class="d-flex align-items-center pagination-panel pagination-table" *ngIf="!loadingPage && !finishScroll">
                <ng-lottie class="lottie-pagination" [options]="{path: 'assets/lotties/loading.json'}"
                    containerClass="loading-box"></ng-lottie>
            </div>
        </div>
    </div>

    <div *ngIf="loaded && !loadingPage && passes.length === 0" class="empty-state">
        <i class="fal fa-id-card"></i>
        <p>No hay abonos</p>
        <span>Da de alta el primer abono para empezar</span>
    </div>
</div>
